import React, { useEffect } from 'react';
import CONFIG from '../../config/config';
import { CSSTransition } from 'react-transition-group';

interface ToastProps {
  message: string;
  id: string;
  removeToast: (id: string) => void;
  type: 'success' | 'error';
  duration?: number;
  action?: React.ReactNode; 
}

const Toast: React.FC<ToastProps> = ({ message, id, removeToast, type = 'success', duration = CONFIG.NOTIFICATION_DECAY, action }) => {
  
  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(id);
    }, duration);
    return () => {
      clearTimeout(timer);
    };
  }, [id, removeToast, duration]);

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={{
        enter: 200,
        exit: 300,
        appear: 500
      }}
      classNames={{
        enter: 'toast-enter',
        enterActive: 'toast-enter-active',
        exit: 'toast-exit',
        exitActive: 'toast-exit-active',
        appear: 'toast-enter',
        appearActive: 'toast-enter-active'
      }}
      unmountOnExit
    >
      <div
        className={`${
          type === 'success' ? 'bg-card text-green-800' : 'bg-card text-red-800'
        } border-l-4 ${
          type === 'success' ? 'border-green-500' : 'border-red-500'
        } rounded-sm px-4 py-3 shadow-md flex items-center space-x-2`}
        role="alert"
        aria-live="assertive"
      >
        <i className={`fas ${type === 'success' ? 'fa-check-circle' : 'fa-times-circle'} text-xl`}></i>
        <p className="flex-1 text-sm">{message}</p>
        {action && <div className="ml-2">{action}</div>}
      </div>
    </CSSTransition>
  );
};

export default Toast;